import { cva } from "class-variance-authority"

export const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        // Every filled surface carries a 1 px foreground stroke (brand rule,
        // and WCAG 1.4.11 — a flat brand fill on the light ground is ~1.3:1 at
        // the edge, so the fill alone cannot delimit the badge).
        default: "border-foreground bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary: "border-foreground bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-foreground bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        success: "border-foreground bg-success text-success-foreground shadow hover:bg-success/80",
        // Flat fill, not a soft tint: the rebranded warning is a light yellow
        // (#FFF890) whose charcoal foreground reads at ~10.6:1, so the tinted
        // `bg-warning/15 text-warning` treatment is no longer needed.
        warning:
          "border-foreground bg-warning text-warning-foreground shadow-none hover:bg-warning/90",
        error:
          "border-foreground bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        disabled: "border-transparent bg-muted text-muted-foreground shadow hover:bg-muted/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)
